import createAxiosInstance from '../../../api';
import { useAlert } from '../../../components/Notification';
import { useDispatch } from 'react-redux';
import { setGlobalAlertAction } from '../../../stores/actionTypes/globalAlertActions';

export function useHook() {
  const axiosInstance = createAxiosInstance();
  const showAlert = useAlert();
  const dispatch = useDispatch();

  const getManufacturedUnitsCount = async (payload) => {
    let data = null;
    await axiosInstance
      .get('/getManufacturedUnitsCount', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((err) => {
        data = null;
      });
    return data;
  };
  const getUnregisteredUnitsCount = async (payload) => {
    let data = null;
    await axiosInstance
      .get('/getUnregisteredUnitsCount', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((err) => {
        data = null;
      });
    return data;
  };

  const getDealerUnregisteredUnitsCount = async (payload) => {
    let data = null;
    await axiosInstance
      .get('/dealers/getUnregisteredUnitsCount', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((err) => {
        data = null;
      });
    return data;
  };

  const getRegisteredUnitsCount = async (payload) => {
    let data = null;
    await axiosInstance
      .get('/getRegisteredUnitsCount', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((err) => {
        data = null;
      });
    return data;
  };

  const getDealerRegisteredUnitsCount = async (payload) => {
    let data = null;
    await axiosInstance
      .get('/dealers/getRegisteredUnitsCount', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((err) => {
        data = null;
      });
    return data;
  };
  const getNumberOfUsers = async (payload) => {
    let data = null;
    await axiosInstance
      .get('/getNumberOfUsers', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((err) => {
        data = null;
      });
    return data;
  };
  const getNumberOfCustomers = async (payload) => {
    let data = null;
    await axiosInstance
      .get('/getNumberOfCustomers', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((err) => {
        data = null;
      });
    return data;
  };
  const getNumberOfDealers = async (payload) => {
    let data = null;
    await axiosInstance
      .get('/getNumberOfDealers', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((err) => {
        data = null;
      });
    return data;
  };

  const getNumberOfActiveSubscription = async (payload) => {
    let data = null;
    await axiosInstance
      .get('/getNumberOfActiveSubscription', payload)
      .then((response) => {
        data = response.data?.data;
      })
      .catch((err) => {
        data = null;
      });
    return data;
  };

  return {
    getManufacturedUnitsCount,
    getUnregisteredUnitsCount,
    getDealerUnregisteredUnitsCount,
    getRegisteredUnitsCount,
    getDealerRegisteredUnitsCount,
    getNumberOfUsers,
    getNumberOfCustomers,
    getNumberOfDealers,
    getNumberOfActiveSubscription,
  };
}
